import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const companySlice = createSlice({
  name: 'company',
  initialState: {
    companyId: '',
  },
  reducers: {
    setCompany: (state, action: PayloadAction<string>) =>{
        state.companyId = action.payload;
    },
    clearCompany: (state) => {
        state.companyId = '';
    }
  },
})

// Action creators are generated for each case reducer function
export const { setCompany, clearCompany } = companySlice.actions

export default companySlice.reducer